// src/modules/app-views/goodsReceipt/pages/Init/components/tableColumns/operationTypeColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
// GoodsReceipt-specific operation type: national vs import (different from invoices exit/entry).
function operationTypeColumn(buildColumnProps, options = {}) {
  return {
    title: translateX('operation'),
    dataIndex: 'operationType',
    ...buildColumnProps('operationType', {
      sort: true,
      filter: true,
      filterOptions: [
        { text: 'national', value: 'national' },
        { text: 'imported', value: 'import' },
      ],
    }),
    width: 110,
    align: 'center',
    render: (_, record) => {
      const type = record?.operationType;
      if (!type) return '—';
      const color = type === 'import' ? 'orange' : 'cyan';
      const label = type === 'import' ? 'importation' : 'national';
      return <Tag color={color}>{translateX(label)}</Tag>;
    },
  };
}

export default operationTypeColumn;
